export default __webpack_public_path__ + "static/media/208-palestine.a23a8f88.svg";